// extracted by mini-css-extract-plugin
module.exports = {"cpBtnTertiary":"StartFundraising_cpBtnTertiary__gp1u1"};